<template>
  <div class="prodcontent">
    <div class="prodbody">
      <div class="bodybottom">
        <div class="divbox"  v-for="item in listdata"  @click="routerpush(item.router)" >
          <div>
            <img :src="getimgsrc(item.titleImg)"/>
          </div>
          <div class="textbox">
            <h1 class="wow fadeInUp" v-html="$i18n.locale=='zh_HK'?item.title:item.titleEn">{{$i18n.locale=='zh_HK'?item.title:item.titleEn}}</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { WOW } from 'wowjs';
  export default {
    name: "prodcontent",
    props: ['listdata'],
    methods:{
      routerpush(to) {
        this.$router.push(to)
      },
      getimgsrc(imgvalue){
        if (imgvalue == null || imgvalue == '') {
          return '-'
        }
        var imgs = imgvalue.replace(/,/g, "")
        return process.env.BASE_IMG + imgs
      },
    },
    mounted(){
      //解决---控制台可能会出现警告
      var options={
        //默认为true
        live:false
      }
      var wow = new WOW(options);
      wow.init();
    },
  }
</script>

<style lang="less" scoped>
  @media only screen and (min-width: 800px) {
    .prodcontent {
      margin-top: -6%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      background-color: #0C2234;
      .prodbody {
        width: 100%;
        /*max-width: 1920px;*/
        display: flex;
        flex-direction: column;
        align-items: center;

        .bodybottom {
          display: flex;
          align-items: flex-start;
          width: 100%;
          justify-content: space-around;
          .divbox:hover{
            transform: scale(1.02);
          }
          .divbox{
            /*width: 42%;*/
            /*float: left;*/
            width: 100%;
            position: relative;
            transition: all 0.3s; //设置动画执行的时间为0.6s
            cursor: pointer;
            div:nth-child(1){
              width: 100%;
              height: 50%;
              img{
                width: 100%;
                clip: rect( -2% 20px 15% 20px);
                margin-top: -2%;
                margin-bottom: -23%;
              }
            }

            .textbox{
              position: absolute;
              bottom: 8%;
              width: 100%;
              color: white;
            }
          }
        }
      }
    }
  }
  // 小于800px
  @media only screen and (max-width: 800px) {
    .prodcontent {
      margin-top: -6%;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      background-color: #0C2234;
      .prodbody {
        width: 100%;
        /*max-width: 1920px;*/
        display: flex;
        flex-direction: column;
        align-items: center;

        .bodybottom {
          display: flex;
          align-items: flex-start;
          width: 100%;
          justify-content: space-around;
          .divbox{
            /*width: 42%;*/
            /*float: left;*/
            width: 100%;
            position: relative;
            div:nth-child(1){
              width: 100%;
              height: 50%;
              img{
                clip: rect( -1% 20px 15% 20px);
                margin-top: -1%;
                margin-bottom: -15%;
                width: 100%;
              }
            }
            .textbox{
              position: absolute;
              bottom: 6%;
              width: 100%;
              color: white;
              h1{
                font-size: 1.6em;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Products/procomponents/prodcontent.vue